export const INTERNALIZATION_CHANGE_LANGUAGE = "@i18n.change.language";
export const INTERNALIZATION_LOAD_CONFIGURATION = "@i18n.load.configuration";
